import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT]: errorToPrint.NOT_ACTIVATABLE_LINES,
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L]: errorToPrint.NOT_ACTIVATABLE_LINES,
          [WEBSERVICE_ERRORS.NOT_ACTIVATABLE_LINES]: errorToPrint.NOT_ACTIVATABLE_LINES,
          [WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS]: errorToPrint.NOT_ACTIVATABLE_LINES,
        },
        [WEB_SERVICES.GET_CQ_PRICES]: {
          [WEBSERVICE_ERRORS.DOBLE_PORTABILITY_RESERVATION]: errorToPrint.GO_TO_900,
          [WEBSERVICE_ERRORS.INCORRECT_BISI_CHARS]: errorToPrint.INCORRECT_BISI_CHARS,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }

  return handledErrors;
}
